import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=49e6a476&scoped=true&"
import script from "./ResizableTextArea.vue?vue&type=script&lang=ts&"
export * from "./ResizableTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableTextArea.vue?vue&type=style&index=0&id=49e6a476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e6a476",
  null
  
)

export default component.exports